import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=381b37bc&scoped=true&"
import script from "./Error500.vue?vue&type=script&lang=js&"
export * from "./Error500.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b37bc",
  null
  
)

export default component.exports